import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const HeaderMenuUserIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>225默认头像</title>
      <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="home-h5-侧拉导航栏"
          transform="translate(-263.000000, -153.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <g id="编组-29" transform="translate(244.000000, 153.000000)">
            <g id="225默认头像" transform="translate(19.000000, 0.000000)">
              <rect id="矩形" opacity="0" x="0" y="0" width="50" height="50"></rect>
              <path
                d="M25,3.125 C12.9296875,3.125 3.125,12.9296875 3.125,25 C3.125,37.0703125 12.9296875,46.875 25,46.875 C37.0703125,46.875 46.875,37.0703125 46.875,25 C46.875,12.9296875 37.0703125,3.125 25,3.125 Z M24.6484375,12.5390625 C28.28125,12.34375 31.25,15.234375 31.25,18.7890625 C31.25,22.2265625 28.4375,25.0390625 25,25.0390625 C21.40625,25.0390625 18.5546875,21.9921875 18.7890625,18.359375 C18.984375,15.234375 21.5234375,12.734375 24.6484375,12.5390625 Z M36.4453125,37.5 L13.59375,37.5 C13.0078125,37.5 12.5390625,37.03125 12.5390625,36.4453125 L12.5390625,33.3203125 C12.5390625,29.1796875 20.859375,27.0703125 25,27.0703125 C29.140625,27.0703125 37.4609375,29.140625 37.4609375,33.3203125 L37.5,36.4453125 C37.5,37.03125 37.03125,37.5 36.4453125,37.5 Z"
                id="形状"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default HeaderMenuUserIcon;
